<div id="reset-view" ng-controller="resetSignatureController as ctrl">
    <div class="wrapper">
        <div class="content">
            <div class="loading"></div>
            <div class="login-wrapper">
                <div ng-if="ctrl.showResetFlow">
                    <form id="reset-form" ng-if="!ctrl.signatureReset" ng-submit="ctrl.resetSignature()">
                        <div class="reset-text">{{ctrl.resetText}} {{ctrl.userEmail}}</div>
                        <div c-password-picker="ctrl.resetPwd" validation-model="ctrl.passwordValidation" model-type="{{ctrl.ctrlType}}" ></div>
                        <button class="save-button" type="submit" ng-disabled="!ctrl.resetPwd">{{ctrl.resetSavePwdText}}</button>
                    </form>
                    <div ng-if="ctrl.signatureReset" class="reset-done">
                        {{'reset.password.done'|translate}}
                    </div>
                    <div ng-if="ctrl.signatureReset" class="return-to-login"><a ng-click="ctrl.returnToLogin()">{{'reset.returnToLogin'|translate}}</a></div>
                    <div ng-if="ctrl.resetError">{{ ctrl.resetError }}</div>
                </div>
                <div ng-if="!ctrl.showResetFlow">
                    {{'reset.noValidSession'|translate}}
                    <div class="return-to-login"><a ng-click="ctrl.forgotSignature()">{{'reset.returnToResetSignature'|translate}}</a></div>
                </div>
            </div>
        </div>
    </div>
</div>